/* Affekt · Online Terapi v4 — tek soru tek ekran randevu formu (1 Kasım 2026)
   v3.1'in eşleştirme, saat, misafir randevu ve ödeme mantığı aynen korunur; yalnızca akış ekranlara bölünür:
   (önceki uzman) → kimin için → konular → etki düzeyi → daha önce terapi → gün ve saat → seans planı → sıklık → iletişim → onay.
   Tek seçimli sorularda yanıt verilince bir sonraki ekran kendiliğinden gelir.
   2 Kasım 2026: "fixed" (uzman kodu) verilirse form yalnızca o uzmanın boş saatleriyle çalışır (uzman profilindeki randevu).
   Arka uç: /apps/terapi/api — /experts, /slots, /me, /hold, /book-credit. Ödeme: sepet + /checkout (iyzico). */
(function () {
  'use strict';
  var API = '/apps/terapi/api';
  var TZ = 'Europe/Istanbul';
  var HOUR = 36e5;
  var SAVE_KEY = 'akf-state-v4';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function tl(n) { return Number(n || 0).toLocaleString('tr-TR') + ' TL'; }
  var fDay = new Intl.DateTimeFormat('tr-TR', { timeZone: TZ, day: 'numeric', month: 'long', weekday: 'long' });
  var fTime = new Intl.DateTimeFormat('tr-TR', { timeZone: TZ, hour: '2-digit', minute: '2-digit' });
  var fWd = new Intl.DateTimeFormat('tr-TR', { timeZone: TZ, weekday: 'short' });
  var fWdLong = new Intl.DateTimeFormat('tr-TR', { timeZone: TZ, weekday: 'long' });
  function noon(date) { return Date.parse(date + 'T12:00:00+03:00'); }
  function day(ts) { return fDay.format(new Date(ts)); }
  function time(ts) { return fTime.format(new Date(ts)); }
  function when(ts) { return day(ts) + ' · ' + time(ts); }
  function hm(min) { return String(Math.floor(min / 60)).padStart(2, '0') + ':' + String(min % 60).padStart(2, '0'); }
  function low(s) { return String(s || '').toLocaleLowerCase('tr'); }

  function api(path, opts) {
    opts = opts || {};
    var init = { method: opts.method || 'GET', credentials: 'same-origin', headers: { 'X-AK': '1', Accept: 'application/json' } };
    if (opts.body) { init.headers['Content-Type'] = 'application/json'; init.body = JSON.stringify(opts.body); }
    return fetch(API + path, init).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) {
        if (!r.ok) { var e = new Error(d.message || 'Bir sorun oluştu. Lütfen tekrar deneyin.'); e.code = d.error; e.status = r.status; throw e; }
        return d;
      });
    }, function () { throw new Error('Bağlantı kurulamadı. İnternet bağlantınızı kontrol edip tekrar deneyin.'); });
  }

  var GK_KEY = 'akf-gk';
  function gkGet() { try { return sessionStorage.getItem(GK_KEY) || ''; } catch (e) { return ''; } }
  function gkSet(v) { try { if (v) sessionStorage.setItem(GK_KEY, v); } catch (e) { /* yok say */ } }
  var RE_MAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function phoneOk(v) { var d = String(v || '').replace(/\D/g, ''); return d.length >= 10 && d.length <= 13; }

  function goCheckout(hold, guest) {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var old = (cart.items || []).filter(function (i) { return i.properties && i.properties._randevu; });
      var chain = Promise.resolve();
      old.forEach(function (i) {
        chain = chain.then(function () {
          return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: i.key, quantity: 0 }) });
        });
      });
      return chain;
    }).then(function () {
      return fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(hold.variant_id), quantity: 1, properties: (function () {
          var p = { _randevu: hold.hold, Seans: hold.label };
          if (guest) { p._ad = guest.name; p._eposta = guest.email; p._telefon = guest.phone; }
          return p;
        })() }] })
      });
    }).then(function (r) {
      if (!r.ok) throw new Error('Sepete eklenemedi. Lütfen tekrar deneyin.');
      location.href = '/checkout' + (guest && guest.email ? '?checkout%5Bemail%5D=' + encodeURIComponent(guest.email) : '');
    });
  }

  var WHO = [
    ['self', 'Kendim için', 'Yetişkin bireysel terapi'],
    ['couple', 'Partnerimle birlikte', 'Çift ve evlilik terapisi'],
    ['teen', 'Ergen çocuğum için', '13–17 yaş · veli bilgisiyle'],
    ['child', 'Çocuğum için', '12 yaş ve altı · veli bilgisiyle']
  ];
  var KIND_OF = { self: 'Yetişkin bireysel', couple: 'Çift', teen: 'Ergen', child: 'Çocuk' };
  var TOPICS = ['Kaygı', 'Depresyon', 'Stres', 'İlişkiler', 'Travma', 'Yas', 'Özsaygı', 'Duygu düzenleme', 'Aile ve ebeveynlik', 'Emin değilim'];
  var LEVELS = [
    ['hafif', 'Biraz', 'Zorlanıyorum ama günlük yaşamım büyük ölçüde sürüyor'],
    ['orta', 'Belirgin şekilde', 'İş, okul veya ilişkilerimi etkilemeye başladı'],
    ['yogun', 'Çok fazla', 'Günlük yaşamımı sürdürmekte zorlanıyorum']
  ];
  var TOD = [['', 'Tümü', 0, 1440], ['sabah', 'Sabah', 0, 720], ['ogle', 'Öğleden sonra', 720, 1020], ['aksam', 'Akşam', 1020, 1440]];

  function parseRules(txt) {
    var out = {};
    String(txt || '').split(/[\n,]+/).forEach(function (line) {
      var m = line.trim().match(/^([a-z0-9_-]+)\s*[=:]\s*(\d+(?:\.\d+)?)\s*(hafif)?$/i);
      if (m) out[m[1].toLowerCase()] = { w: Number(m[2]), mild: !!m[3] };
    });
    return out;
  }

  function initForm(root) {
    var cfg = JSON.parse($('script[type="application/json"]', root).textContent);
    var rules = parseRules(cfg.rules);
    var EX = {};
    cfg.experts.forEach(function (e) { EX[e.id] = e; });
    var FIX = cfg.fixed && EX[cfg.fixed] ? cfg.fixed : '';
    var saveKey = SAVE_KEY + (FIX ? ':' + FIX : '');
    var body = $('[data-akf-body]', root);
    var st = {
      scr: 'who', who: '', topics: [], level: '', before: '',
      prev: null, keep: null, credits: {},
      tod: '', day: 0, slot: null, expert: null,
      kind: 'single', repeat: false, planSet: false, repeatSet: false,
      child_name: '', child_age: '', partner_name: '', phone: cfg.phone || '', note: '', kvkk: false, consent: false, reminders: true,
      gname: '', gmail: '',
      from: ''
    };
    var cache = { live: null, slots: {}, union: null, key: '' };
    var msg = '', dir = 1, lock = false;
    var tried = {};

    // ---------- ekran sırası ----------
    function screens() {
      var l = [];
      if (!FIX && st.prev && EX[st.prev]) l.push('keep');
      return l.concat(['who', 'topic', 'level', 'before', 'time', 'plan', 'repeat', 'contact', 'confirm']);
    }
    function idx() { return Math.max(0, screens().indexOf(st.scr)); }
    function firstOpen() {
      if (!FIX && st.prev && EX[st.prev] && st.keep === null) return 'keep';
      if (!st.who) return 'who';
      if (!st.topics.length) return 'topic';
      if (!st.level) return 'level';
      return 'time';
    }

    // ---------- önceki durum / dış bağlantıdan gelen yanıtlar ----------
    function restore() {
      try {
        var raw = sessionStorage.getItem(saveKey);
        if (raw) {
          sessionStorage.removeItem(saveKey);
          var o = JSON.parse(raw);
          if (o && o.at > Date.now() - 2 * HOUR) {
            Object.keys(st).forEach(function (k) { if (k in o.st) st[k] = o.st[k]; });
            st.kvkk = false; st.consent = false;
            return true;
          }
        }
      } catch (e) { /* sessionStorage kapalı olabilir */ }
      var q = new URLSearchParams(location.search);
      var kim = q.get('kim');
      if (kim && KIND_OF[kim]) st.who = kim;
      var konu = q.get('konu');
      if (konu) st.topics = konu.split(',').map(function (t) { return t.trim(); }).filter(function (t) { return TOPICS.indexOf(t) >= 0; });
      var etki = q.get('etki');
      if (LEVELS.some(function (l) { return l[0] === etki; })) st.level = etki;
      var once = q.get('once');
      if (once === 'yes' || once === 'no') st.before = once;
      var zaman = q.get('zaman');
      if (TOD.some(function (t) { return t[0] === zaman; })) st.tod = zaman;
      if (q.get('kaynak')) st.from = String(q.get('kaynak')).slice(0, 30);
      st.scr = firstOpen();
      return !!kim;
    }
    function save() {
      try { sessionStorage.setItem(saveKey, JSON.stringify({ at: Date.now(), st: st })); } catch (e) { /* yok say */ }
    }

    // ---------- uygunluk ----------
    function eligible() {
      var live = cache.live || {};
      if (FIX) return live[FIX] ? [FIX] : [];
      var need = KIND_OF[st.who] || 'Yetişkin bireysel';
      if (st.prev && st.keep) return EX[st.prev] && live[st.prev] ? [st.prev] : [];
      return cfg.experts.filter(function (e) {
        if (!live[e.id]) return false;
        return e.kinds.indexOf(need) >= 0;
      }).map(function (e) { return e.id; });
    }
    function loadLive() {
      if (cache.live) return Promise.resolve(cache.live);
      return api('/experts').then(function (d) {
        var live = {};
        (d.experts || []).forEach(function (e) { if (e.variants && e.variants.single) live[e.id] = e; });
        cache.live = live;
        return live;
      });
    }
    var FB = cfg.fallback || 'pelda';
    function loadUnion() {
      var ids = eligible();
      var key = ids.join(',');
      if (cache.union && cache.key === key) return Promise.resolve(cache.union);
      return buildUnion(ids).then(function (days) {
        if (FIX || days.length || !EX[FB] || !(cache.live || {})[FB] || (ids.length === 1 && ids[0] === FB)) return days;
        return buildUnion([FB]);
      }).then(function (days) {
        cache.union = days;
        cache.key = key;
        return days;
      });
    }
    function buildUnion(ids) {
      return Promise.all(ids.map(function (id) {
        if (cache.slots[id]) return Promise.resolve(cache.slots[id]);
        return api('/slots?expert=' + encodeURIComponent(id) + '&days=21').then(function (d) {
          cache.slots[id] = d;
          if (d.credits) st.credits[id] = d.credits;
          return d;
        }).catch(function () { return null; });
      })).then(function (res) {
        var byDate = {};
        res.forEach(function (d, i) {
          if (!d) return;
          var id = ids[i];
          (d.days || []).forEach(function (dd) {
            (dd.slots || []).forEach(function (s) {
              if (s.busy) return;
              var dy = byDate[dd.date] = byDate[dd.date] || {};
              var slot = dy[s.ts] = dy[s.ts] || { ts: s.ts, min: s.min, ex: [] };
              slot.ex.push(id);
            });
          });
        });
        return Object.keys(byDate).sort().map(function (date) {
          var slots = Object.keys(byDate[date]).map(function (k) { return byDate[date][k]; }).sort(function (a, b) { return a.ts - b.ts; });
          return { date: date, slots: slots };
        }).filter(function (d) { return d.slots.length; });
      });
    }
    function hits(id) {
      var t = (EX[id] && EX[id].topics) || [];
      return st.topics.filter(function (x) { return t.indexOf(x) >= 0; }).length;
    }
    function pick(list) {
      var ws = list.map(function (id) { return rules[id].w * (1 + 0.25 * hits(id)); });
      var sum = ws.reduce(function (a, b) { return a + b; }, 0), r = Math.random() * sum;
      for (var i = 0; i < list.length; i++) { r -= ws[i]; if (r < 0) return list[i]; }
      return list[list.length - 1];
    }
    function assign(slot) {
      var c = slot.ex.slice();
      if (!c.length) return null;
      if (FIX) return c.indexOf(FIX) >= 0 ? FIX : null;
      if (c.length === 1) return c[0];
      if (st.level === 'hafif') {
        var m = c.filter(function (id) { var r = rules[id]; return r && r.w > 0 && r.mild; });
        if (m.length) return pick(m);
      }
      var t1 = c.filter(function (id) { var r = rules[id]; return r && r.w > 0 && !r.mild; });
      if (t1.length) return pick(t1);
      var best = Math.max.apply(null, c.map(hits));
      var top = c.filter(function (id) { return hits(id) === best; });
      return top[Math.floor(Math.random() * top.length)];
    }
    // Tek uzman modunda yalnızca uzmanın çalıştığı terapi türleri sorulur
    function whoList() {
      if (!FIX) return WHO;
      var k = EX[FIX].kinds || [];
      var l = WHO.filter(function (w) { return k.indexOf(KIND_OF[w[0]]) >= 0; });
      return l.length ? l : WHO;
    }

    // ---------- görünüm parçaları ----------
    var IC = {
      tick: '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
      back: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 12H5M11 6l-6 6 6 6"/></svg>',
      next: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
      cal: '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="3"/><path d="M3 10h18M8 3v4M16 3v4M10 15h4"/></svg>',
      alert: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5M12 16.5h.01"/></svg>'
    };
    function opt(act, val, on, title, sub, extra) {
      return '<button type="button" class="akf-opt' + (extra ? ' ' + extra : '') + '" aria-pressed="' + on + '" data-f="' + act + '" data-v="' + esc(val) + '">' +
        '<span class="akf-opt__tx"><b>' + esc(title) + '</b>' + (sub ? '<span>' + esc(sub) + '</span>' : '') + '</span>' +
        '<span class="akf-opt__ck" aria-hidden="true">' + IC.tick + '</span></button>';
    }
    function chip(act, val, on, title) {
      return '<button type="button" class="akf-chip" aria-pressed="' + on + '" data-f="' + act + '" data-v="' + esc(val) + '">' + (on ? IC.tick : '') + esc(title) + '</button>';
    }
    function head(title, hint) {
      return '<div class="akf-qh"><h3 class="akf-qt" tabindex="-1">' + esc(title) + '</h3>' + (hint ? '<p class="akf-qs">' + esc(hint) + '</p>' : '') + '</div>';
    }
    function err(text) { return '<p class="akf-err" role="alert">' + IC.alert + '<span>' + esc(text) + '</span></p>'; }
    function top() {
      var l = screens(), i = idx(), pct = Math.round((i + 1) / l.length * 100);
      return '<div class="akf-top">' +
        (i > 0 ? '<button type="button" class="akf-tback" data-f="back" aria-label="Önceki soru">' + IC.back + '</button>' : '<span class="akf-tback akf-tback--off" aria-hidden="true"></span>') +
        '<div class="akf-tbar" role="progressbar" aria-valuemin="1" aria-valuemax="' + l.length + '" aria-valuenow="' + (i + 1) + '" aria-label="Form ilerlemesi"><i style="width:' + pct + '%"></i></div>' +
        '<span class="akf-tn">' + (i + 1) + '/' + l.length + '</span></div>';
    }
    function bar(label, opts) {
      opts = opts || {};
      return '<div class="akf-bar">' + (opts.price ? '<div class="akf-bar__p"><span>Seans ücreti <small>KDV dahil</small></span><b>' + esc(opts.price) + '</b></div>' : '') +
        '<div class="akf-bar__b"><button type="button" class="ak-btn ak-btn--accent akf-next" data-f="' + (opts.act || 'next') + '"' + (opts.off ? ' disabled' : '') + '>' + esc(label) + (opts.act === 'submit' ? '' : IC.next) + '</button></div></div>';
    }
    function msgBox() { return msg ? '<p class="akf-msg" role="alert">' + IC.alert + '<span>' + esc(msg) + '</span></p>' : ''; }
    function info(text, kind) { return '<p class="akf-info' + (kind ? ' akf-info--' + kind : '') + '">' + text + '</p>'; }

    // ---------- ekranlar ----------
    function viewKeep() {
      var p = EX[st.prev];
      return head('Daha önce ' + p.title + ' ' + p.name + ' ile görüştünüz. Aynı uzmanla devam etmek ister misiniz?') +
        '<div class="akf-col">' + opt('keep', '1', st.keep === true, 'Evet, devam edelim', st.credits[st.prev] ? st.credits[st.prev] + ' seans hakkınız var' : 'Aynı uzmanın boş saatleri') +
        opt('keep', '0', st.keep === false, 'Hayır', 'Bana uygun uzmanı siz belirleyin') + '</div>';
    }
    function viewWho() {
      var h = st.from === 'affektmag' ? info('affektmag.com’da verdiğiniz yanıtlar forma aktarıldı.', 'ok') : '';
      return h + head('Seans kimin için?') + '<div class="akf-g2">' + whoList().map(function (w) { return opt('who', w[0], st.who === w[0], w[1], w[2]); }).join('') + '</div>';
    }
    function viewTopic() {
      return head('Neler üzerinde çalışmak istersiniz?', 'Birden fazla seçebilirsiniz.') +
        '<div class="akf-chips">' + TOPICS.map(function (t) { return chip('topic', t, st.topics.indexOf(t) >= 0, t); }).join('') + '</div>' +
        (tried.topic && !st.topics.length ? err('Lütfen en az bir konu seçin.') : '') +
        bar('Devam edin', { off: !st.topics.length });
    }
    function viewLevel() {
      var h = head('Bu durum günlük yaşamınızı ne ölçüde etkiliyor?') + '<div class="akf-col">' + LEVELS.map(function (l) { return opt('level', l[0], st.level === l[0], l[1], l[2]); }).join('') + '</div>';
      if (st.level === 'yogun') h += info('Kendinizin veya bir başkasının güvenliği tehlikedeyse lütfen beklemeyin; <b>112</b>’yi arayın ya da en yakın acil servise başvurun. Online terapi acil destek hizmeti sunmaz.', 'warn') + bar('Devam edin');
      return h;
    }
    function viewBefore() {
      return head('Daha önce terapi aldınız mı?', 'İsteğe bağlı') +
        '<div class="akf-g2">' + opt('before', 'yes', st.before === 'yes', 'Evet', 'Daha önce terapi aldım') + opt('before', 'no', st.before === 'no', 'Hayır', 'İlk kez alacağım') + '</div>' +
        '<button type="button" class="akf-skip" data-f="next">Bu soruyu geçin</button>';
    }
    function skeleton() {
      var d = '', s = '';
      for (var i = 0; i < 6; i++) d += '<span class="akf-sk akf-sk--day"></span>';
      for (var j = 0; j < 6; j++) s += '<span class="akf-sk akf-sk--slot"></span>';
      return '<div class="akf-load" aria-busy="true"><span class="ak-sr">Uygun saatler yükleniyor</span><span class="akf-sk akf-sk--seg"></span><div class="akf-days akf-days--sk">' + d + '</div><div class="akf-slots">' + s + '</div></div>';
    }
    function viewTime() {
      var h = head('Size uyan gün ve saati seçin', FIX ? 'Gösterilen saatlerin tümü ' + EX[FIX].name + ' için boş.' : 'O saatte boş olan uzmanlarımızdan size en uygun olanı biz belirleriz.');
      var days = cache.key === eligible().join(',') ? cache.union : null;
      if (!days) {
        if (!cache.loading) {
          cache.loading = true;
          loadLive().then(loadUnion).then(function () { cache.loading = false; render(); })
            .catch(function (e) { cache.loading = false; msg = e.message; cache.union = []; cache.key = eligible().join(','); render(); });
        }
        return h + skeleton();
      }
      if (!days.length) {
        if (FIX) {
          return h + '<div class="akf-empty"><span class="akf-empty__ic">' + IC.cal + '</span><b>Şu an boş saat görünmüyor</b><p>Uzmanımız yeni saatler açtığında burada görünecek. Dilerseniz online terapi formunu doldurun; boş saati olan uzmanlarımızdan size uygun olanı eşleştirelim.</p>' +
            '<a class="ak-btn ak-btn--line" href="' + esc(cfg.formUrl || '/pages/online-terapi#randevu-formu') + '">Online terapi formuna gidin</a></div>' + msgBox();
        }
        return h + '<div class="akf-empty"><span class="akf-empty__ic">' + IC.cal + '</span><b>Şu an uygun saat görünmüyor</b><p>Uzmanlarımız yeni saatler açtıkça burada görünecek. Size uygun bir saat bulmamız için bize yazabilirsiniz.</p>' +
          (cfg.whatsapp ? '<a class="ak-btn ak-btn--line" href="https://wa.me/' + esc(cfg.whatsapp) + '?text=' + encodeURIComponent('Merhaba, online terapi randevusu için uygun saat arıyorum.') + '" target="_blank" rel="noopener">WhatsApp’tan yazın</a>' : '') + '</div>' + msgBox();
      }
      var g = TOD.filter(function (t) { return t[0] === st.tod; })[0] || TOD[0];
      var inTod = function (s) { return s.min >= g[2] && s.min < g[3]; };
      h += '<div class="akf-seg" role="group" aria-label="Gün içinde zaman">' + TOD.map(function (t) {
        return '<button type="button" aria-pressed="' + (st.tod === t[0]) + '" data-f="tod" data-v="' + t[0] + '">' + esc(t[0] === 'ogle' ? 'Öğle' : t[1]) + '</button>';
      }).join('') + '</div>';
      var vis = days.map(function (d, i) { return { d: d, i: i, n: d.slots.filter(inTod).length }; });
      if (!vis[st.day] || !vis[st.day].n) {
        var f = vis.filter(function (x) { return x.n; })[0];
        st.day = f ? f.i : 0;
      }
      h += '<div class="akf-days" role="group" aria-label="Gün seçin">' + vis.map(function (x) {
        return '<button type="button" class="akf-day" aria-pressed="' + (st.day === x.i) + '" data-f="day" data-v="' + x.i + '"' + (x.n ? '' : ' disabled') + ' aria-label="' + esc(day(noon(x.d.date))) + ', ' + x.n + ' boş saat">' +
          '<span>' + esc(fWd.format(new Date(noon(x.d.date)))) + '</span><b>' + Number(x.d.date.slice(8, 10)) + '</b><small>' + (x.n ? x.n + ' saat' : 'dolu') + '</small></button>';
      }).join('') + '</div>';
      var cur = days[st.day];
      var sl = cur.slots.filter(inTod);
      h += '<p class="akf-dayt">' + esc(day(noon(cur.date))) + ' <small>Türkiye saati</small></p>';
      h += sl.length ? '<div class="akf-slots">' + sl.map(function (s) {
        return '<button type="button" class="akf-slot" aria-pressed="' + (st.slot === s.ts) + '" data-f="slot" data-v="' + s.ts + '">' + hm(s.min) + '</button>';
      }).join('') + '</div>' : info('Bu zaman diliminde boş saat yok. “Tümü”nü seçerek diğer saatlere bakabilirsiniz.');
      return h + msgBox();
    }
    function prices() { var e = EX[st.expert]; return (e && e.prices) || {}; }
    function disc(n) { var P = prices(); var full = P.single * n, pk = P['pack' + n]; return full && pk ? Math.round(100 - pk * 100 / full) : 0; }
    function viewPlan() {
      var P = prices(), cr = st.credits[st.expert] || 0;
      var packs = [];
      if (cr > 0) packs.push(['credit', 'Paketimden kullan', cr + ' seans hakkınız var', '']);
      packs.push(['single', 'Tek seans', '1 seans · 50 dk · ' + tl(P.single), '']);
      if (P.pack4) packs.push(['pack4', '4 seanslık paket', '4 seans · 50 dk · ' + tl(P.pack4), disc(4) ? '%' + disc(4) + ' indirim' : '']);
      if (P.pack8) packs.push(['pack8', '8 seanslık paket', '8 seans · 50 dk · ' + tl(P.pack8), disc(8) ? '%' + disc(8) + ' indirim' : '']);
      if (!packs.some(function (p) { return p[0] === st.kind; })) st.kind = cr > 0 ? 'credit' : 'single';
      return info(FIX ? '<b>' + esc(when(st.slot)) + '</b> seçildi.' : '<b>' + esc(when(st.slot)) + '</b> için size uygun uzman ayrıldı.', 'ok') +
        head('Tek seans mı, paket mi?') + '<div class="akf-col">' + packs.map(function (p) {
          return '<button type="button" class="akf-opt akf-opt--row" aria-pressed="' + (st.planSet && st.kind === p[0]) + '" data-f="kind" data-v="' + p[0] + '"><span class="akf-opt__tx"><b>' + esc(p[1]) + '</b><span>' + esc(p[2]) + '</span></span>' +
            (p[3] ? '<span class="akf-badge">' + esc(p[3]) + '</span>' : '') + '<span class="akf-opt__ck" aria-hidden="true">' + IC.tick + '</span></button>';
        }).join('') + '</div>';
    }
    function viewRepeat() {
      var wd = low(fWdLong.format(new Date(st.slot)));
      return head('Ne sıklıkla görüşmek istersiniz?') + '<div class="akf-g2">' +
        opt('repeat', '0', st.repeatSet && !st.repeat, 'Tek seferlik', 'Sonrakini sonra seçerim') +
        opt('repeat', '1', st.repeatSet && st.repeat, 'Her hafta', 'Her ' + wd + ' ' + time(st.slot)) + '</div>';
    }
    function viewContact() {
      var t = tried.contact, h = '';
      var child = st.who === 'child' || st.who === 'teen';
      h += head(cfg.loggedIn ? 'Birkaç bilgi' : 'İletişim bilgileriniz', cfg.loggedIn ? '' : 'Üyelik gerekmez. Randevu onayınızı ve görüşme bilgilerini bu bilgilerle iletiriz.');
      h += '<div class="akf-fields">';
      if (child) {
        var cnBad = t && !st.child_name.trim();
        h += '<div class="akf-g2 akf-g2--f"><div class="ak-field' + (cnBad ? ' is-bad' : '') + '"><label for="akf-cn">Çocuğunuzun adı</label><input class="ak-input" id="akf-cn" data-in="child_name" maxlength="80" autocomplete="off" value="' + esc(st.child_name) + '">' + (cnBad ? '<span class="akf-err">' + IC.alert + '<span>Lütfen adını yazın.</span></span>' : '') + '</div>' +
          '<div class="ak-field"><label for="akf-ca">Yaşı</label><input class="ak-input" id="akf-ca" data-in="child_age" type="number" min="3" max="17" inputmode="numeric" value="' + esc(st.child_age) + '"></div></div>';
      }
      if (st.who === 'couple') h += '<div class="ak-field"><label for="akf-pn">Partnerinizin adı <span class="akf-opt-l">İsteğe bağlı</span></label><input class="ak-input" id="akf-pn" data-in="partner_name" maxlength="80" autocomplete="off" value="' + esc(st.partner_name) + '"></div>';
      if (!cfg.loggedIn) {
        h += gField('gname', 'akf-gn', 'Adınız ve soyadınız', 'text', 'name', 'off', 80) +
          gField('gmail', 'akf-gm', 'E-posta adresiniz', 'email', 'email', 'email', 120) +
          gField('phone', 'akf-ph', 'WhatsApp İletişim Numaranız', 'tel', 'tel', 'tel', 30, 'Örnek: 0532 123 45 67');
        if (child) h += '<p class="akf-small">Yazdığınız iletişim bilgileri veli olarak sizin bilgilerinizdir.</p>';
        h += '<p class="akf-small">Hesabınız var mı? <a href="' + esc(cfg.login) + '" data-f="login">Giriş yapın</a>; paketinizdeki seanslar ve önceki uzmanınız görünsün.</p>';
      } else {
        h += '<div class="ak-field"><label for="akf-ph">WhatsApp İletişim Numaranız</label><input class="ak-input" id="akf-ph" data-in="phone" type="tel" inputmode="tel" autocomplete="tel" value="' + esc(st.phone) + '"><span class="akf-small">Gerektiğinde Affekt ekibi WhatsApp’tan bilgi verir.</span></div>';
      }
      h += '</div>';
      return h + bar('Devam edin');
    }
    function check(key, text, req, bad) {
      return '<label class="akf-check' + (bad ? ' is-bad' : '') + '"><input type="checkbox" data-in="' + key + '"' + (st[key] ? ' checked' : '') + '><span class="akf-check__b" aria-hidden="true">' + IC.tick + '</span><span class="akf-check__t">' + text + (req ? ' <b>Zorunlu</b>' : '') + '</span></label>';
    }
    function viewConfirm() {
      var e = EX[st.expert] || {}, P = prices();
      var price = st.kind === 'credit' ? 'Paketinizden' : tl(P[st.kind]);
      var plan = st.kind === 'credit' ? 'Paketinizden 1 seans' : st.kind === 'single' ? 'Tek seans · 50 dk' : (st.kind === 'pack4' ? '4' : '8') + ' seanslık paket';
      var t = tried.confirm;
      var h = head('Son kontrol', 'Uzmanınız ve randevu bilgileriniz aşağıda.');
      h += '<div class="akf-match">' +
        (e.photo ? '<img class="akf-match__img" src="' + esc(e.photo) + '" alt="" width="64" height="64">' : '<span class="akf-match__img akf-match__ini" aria-hidden="true">' + esc(String(e.name || '?').split(' ').map(function (w) { return w.charAt(0); }).slice(0, 2).join('')) + '</span>') +
        '<div class="akf-match__tx"><span class="akf-match__k">' + (FIX ? 'Uzmanınız' : 'Size eşleştirilen uzman') + '</span><span class="akf-match__r">' + esc(e.title) + '</span><b>' + esc(e.name) + '</b>' +
        (e.url && !FIX ? '<a href="' + esc(e.url) + '" target="_blank" rel="noopener">Uzmanı tanıyın</a>' : '') + '</div></div>';
      h += '<dl class="akf-sum"><div><dt>Gün ve saat</dt><dd>' + esc(when(st.slot)) + (st.repeat ? ' · her hafta' : '') + '</dd></div><div><dt>Seans planı</dt><dd>' + esc(plan) + '</dd></div><div><dt>Görüşme</dt><dd>Görüntülü · 50 dakika</dd></div></dl>';
      if (st.repeat) {
        var wd = low(fWdLong.format(new Date(st.slot)));
        h += '<p class="akf-small">' + (st.kind === 'single'
          ? 'Her ' + esc(wd) + ' ' + time(st.slot) + ' sizin için ayrılır. Sonraki seansların ödemesini Seanslarım sayfasından, seanstan 2 gün öncesine kadar yaparsınız; yapılmazsa o haftanın saati başkasına açılır.'
          : 'Seanslarınız her ' + esc(wd) + ' ' + time(st.slot) + ' için otomatik ayrılır. Bir haftayı atlamak isterseniz Seanslarım sayfasından iptal edersiniz; hakkınız geri gelir.') + '</p>';
      }
      h += '<details class="akf-note"' + (st.note ? ' open' : '') + '><summary>Uzmanınıza not ekleyin <span>İsteğe bağlı</span></summary><textarea class="ak-textarea" id="akf-note" data-in="note" maxlength="800" aria-label="Uzmanınıza not" placeholder="Birkaç cümle yeterli. İlk seansta ayrıntılı konuşacaksınız.">' + esc(st.note) + '</textarea></details>';
      h += '<div class="akf-checks">' +
        check('kvkk', '<a href="' + esc(cfg.kvkk) + '" target="_blank" rel="noopener">Kişisel Verilerin Korunması Aydınlatma Metni</a>’ni okudum.', true, t && !st.kvkk) +
        check('consent', esc(cfg.consent), true, t && !st.consent) +
        check('reminders', 'Seansımdan 1 gün önce e-posta ile hatırlatma almak istiyorum.', false, false) + '</div>' +
        '<p class="akf-small">İptal en az 48 saat, gün veya saat değişikliği en az 24 saat önce. Ödeme iyzico güvenli ödeme sayfasında alınır; kart bilgileriniz Affekt tarafından saklanmaz.</p>';
      h += msgBox();
      return h + bar(st.kind === 'credit' ? 'Seansı onaylayın' : 'Ödemeye geçin', { act: 'submit', price: price });
    }

    // Misafir iletişim alanları
    var touched = {};
    function gErr(key) {
      var v = String(st[key] || '').trim();
      if (key === 'gname') return v.length < 3 || v.indexOf(' ') < 0 ? (v ? 'Lütfen adınızı ve soyadınızı birlikte yazın.' : 'Lütfen adınızı ve soyadınızı yazın.') : '';
      if (key === 'gmail') return !v ? 'Lütfen e-posta adresinizi yazın.' : !RE_MAIL.test(v) ? 'E-posta adresiniz eksik ya da hatalı görünüyor.' : '';
      if (key === 'phone') return !v ? 'Lütfen WhatsApp iletişim numaranızı yazın.' : !phoneOk(v) ? 'Numaranız eksik görünüyor; başında 0 ile 11 hane yazabilirsiniz.' : '';
      return '';
    }
    function gField(key, id, label, type, ac, im, max, hint) {
      var e = (tried.contact || touched[key]) ? gErr(key) : '';
      return '<div class="ak-field' + (e ? ' is-bad' : '') + '" data-fk="' + key + '"><label for="' + id + '">' + esc(label) + '</label>' +
        '<input class="ak-input" id="' + id + '" data-in="' + key + '" type="' + type + '" autocomplete="' + ac + '"' + (im !== 'off' ? ' inputmode="' + im + '"' : '') + ' maxlength="' + max + '" value="' + esc(st[key]) + '"' + (e ? ' aria-invalid="true" aria-describedby="' + id + '-e"' : '') + '>' +
        (e ? '<span class="akf-err" id="' + id + '-e">' + IC.alert + '<span>' + esc(e) + '</span></span>' : '') +
        (hint ? '<span class="akf-small">' + esc(hint) + '</span>' : '') + '</div>';
    }
    function gMark(key) {
      var box = $('.ak-field[data-fk="' + key + '"]', body);
      if (!box) return;
      var inp = $('input', box), id = inp.id, e = gErr(key), old = $('.akf-err', box);
      box.classList.toggle('is-bad', !!e);
      if (e) { inp.setAttribute('aria-invalid', 'true'); inp.setAttribute('aria-describedby', id + '-e'); }
      else { inp.removeAttribute('aria-invalid'); inp.removeAttribute('aria-describedby'); }
      if (!e) { if (old) old.parentNode.removeChild(old); return; }
      if (old) { $('span', old).textContent = e; return; }
      var s = document.createElement('span');
      s.className = 'akf-err'; s.id = id + '-e'; s.innerHTML = IC.alert + '<span>' + esc(e) + '</span>';
      inp.insertAdjacentElement('afterend', s);
    }
    function contactBad() {
      if ((st.who === 'child' || st.who === 'teen') && !st.child_name.trim()) return true;
      return !cfg.loggedIn && ['gname', 'gmail', 'phone'].some(function (k) { return !!gErr(k); });
    }

    var VIEWS = { keep: viewKeep, who: viewWho, topic: viewTopic, level: viewLevel, before: viewBefore, time: viewTime, plan: viewPlan, repeat: viewRepeat, contact: viewContact, confirm: viewConfirm };
    function render() {
      if (screens().indexOf(st.scr) < 0) st.scr = firstOpen();
      body.innerHTML = top() + '<div class="akf-pane" data-scr="' + st.scr + '" data-dir="' + (dir < 0 ? 'b' : dir > 0 ? 'f' : 'n') + '">' + VIEWS[st.scr]() + '</div>';
      dir = 0;
    }
    function headerH() {
      var h = document.querySelector('.ak-header-section, .shopify-section-group-header-group, header');
      if (!h) return 0;
      var r = h.getBoundingClientRect();
      return getComputedStyle(h).position === 'sticky' || getComputedStyle(h).position === 'fixed' ? Math.max(0, r.bottom) : 0;
    }
    function toTop(smooth) {
      var off = headerH() + 8;
      var t = root.getBoundingClientRect().top;
      if (t >= off - 1 && t < window.innerHeight * 0.4) return;
      var y = Math.max(0, window.pageYOffset + t - off);
      if (y > window.pageYOffset && t >= off) return;
      window.scrollTo({ top: y, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function goTo(scr, back) {
      var ae = document.activeElement;
      if (ae && root.contains(ae) && ae.blur) ae.blur();
      var y = window.pageYOffset;
      st.scr = scr; msg = ''; dir = back ? -1 : 1;
      render();
      if (Math.abs(window.pageYOffset - y) > 1) window.scrollTo(0, y);
      toTop();
      var qt = $('.akf-qt', body);
      if (qt && qt.focus) try { qt.focus({ preventScroll: true }); } catch (e) { /* eski tarayıcı */ }
    }
    function next() { var l = screens(), i = idx(); if (i < l.length - 1) goTo(l[i + 1]); }
    function back() { var l = screens(), i = idx(); if (i > 0) goTo(l[i - 1], true); }
    // Tek seçimli yanıtta seçimin görünmesi için kısa bir bekleme, sonra sonraki ekran
    function auto() {
      if (lock) return;
      lock = true;
      setTimeout(function () { lock = false; next(); }, 260);
    }
    function firstBad() {
      var el = $('.is-bad', body);
      if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    function intakeNote() {
      var w = (WHO.filter(function (x) { return x[0] === st.who; })[0] || [])[1] || '';
      var l = (LEVELS.filter(function (x) { return x[0] === st.level; })[0] || [])[1] || '';
      var hd = (FIX ? 'Uzman profilinden randevu' : 'Online terapi formu') + ' · ' + w + ' · Konular: ' + st.topics.join(', ') + ' · Günlük yaşama etkisi: ' + l + (st.from ? ' · Kaynak: ' + st.from : '');
      return (hd + (st.note ? '\n' + st.note : '')).slice(0, 1000);
    }
    function submit(btn) {
      var guest = !cfg.loggedIn;
      if (contactBad()) { tried.contact = true; goTo('contact', true); return firstBad(); }
      if (!st.kvkk || !st.consent) { tried.confirm = true; msg = 'Devam etmek için işaretli alanları tamamlayın.'; render(); return firstBad(); }
      var intake = {
        who: st.who === 'teen' ? 'child' : st.who, child_name: st.child_name.trim(), child_age: st.child_age, partner_name: st.partner_name.trim(),
        before: st.before, note: intakeNote(), phone: st.phone.trim(), reminders: !!st.reminders, consent_health: true
      };
      btn.disabled = true; btn.textContent = 'Lütfen bekleyin…'; btn.classList.add('is-busy');
      var p = st.kind === 'credit'
        ? api('/book-credit', { method: 'POST', body: { expert: st.expert, start: st.slot, recurring: st.repeat, intake: intake } }).then(function () {
            body.innerHTML = '<div class="akf-done"><span class="akf-done__ic" aria-hidden="true">' + IC.tick + '</span><h3 class="ak-h2">Randevunuz <span class="ak-serif">kesinleşti</span></h3><p class="ak-sub">' +
              esc(when(st.slot)) + (st.repeat ? ' · her hafta' : '') + '. Görüşme bağlantısını uzmanınız seanstan önce iletecek.</p><a class="ak-btn ak-btn--accent" href="/pages/seanslarim">Seanslarımı görün</a></div>';
          })
        : (function () {
            var g = guest ? { name: st.gname.trim().replace(/\s+/g, ' '), email: st.gmail.trim().toLowerCase(), phone: st.phone.trim() } : null;
            var req = { expert: st.expert, start: st.slot, kind: st.kind, recurring: st.repeat, intake: intake };
            if (g) { req.guest = g; if (gkGet()) req.gk = gkGet(); }
            return api('/hold', { method: 'POST', body: req }).then(function (hold) {
              if (hold.gk) gkSet(hold.gk);
              return goCheckout(hold, g);
            });
          })();
      p.catch(function (e) {
        if (e.code === 'slot_taken') {
          cache.union = null; cache.slots = {}; st.slot = null; st.expert = null;
          goTo('time', true); msg = 'Seçtiğiniz saat az önce doldu. Lütfen başka bir saat seçin.'; render();
          return;
        }
        if (e.status === 401) { save(); location.href = cfg.login; return; }
        msg = e.message; render();
      });
    }

    root.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-f]');
      if (!b || b.disabled || lock) return;
      var f = b.getAttribute('data-f'), v = b.getAttribute('data-v');
      msg = '';
      if (f === 'who') { if (st.who !== v) { st.who = v; st.slot = null; st.expert = null; } render(); return auto(); }
      if (f === 'keep') { st.keep = v === '1'; st.slot = null; st.expert = null; render(); return auto(); }
      if (f === 'topic') {
        var i = st.topics.indexOf(v);
        if (i >= 0) st.topics.splice(i, 1);
        else if (v === 'Emin değilim') st.topics = [v];
        else { st.topics = st.topics.filter(function (t) { return t !== 'Emin değilim'; }); st.topics.push(v); }
        return render();
      }
      if (f === 'level') { st.level = v; render(); return v === 'yogun' ? null : auto(); }
      if (f === 'before') { st.before = v; render(); return auto(); }
      if (f === 'tod') { st.tod = v; return render(); }
      if (f === 'day') { st.day = Number(v); return render(); }
      if (f === 'slot') {
        var ts = Number(v), cur = (cache.union || [])[st.day];
        var s = cur && cur.slots.filter(function (x) { return x.ts === ts; })[0];
        if (s) { st.slot = ts; st.expert = assign(s); render(); return auto(); }
        return;
      }
      if (f === 'kind') { st.kind = v; st.planSet = true; render(); return auto(); }
      if (f === 'repeat') { st.repeat = v === '1'; st.repeatSet = true; render(); return auto(); }
      if (f === 'next') {
        if (st.scr === 'topic' && !st.topics.length) { tried.topic = true; return render(); }
        if (st.scr === 'contact' && contactBad()) { tried.contact = true; render(); return firstBad(); }
        return next();
      }
      if (f === 'back') return back();
      if (f === 'submit') return submit(b);
      if (f === 'login') { ev.preventDefault(); save(); location.href = cfg.login; }
    });
    root.addEventListener('input', function (ev) {
      var k = ev.target.getAttribute && ev.target.getAttribute('data-in');
      if (!k) return;
      st[k] = ev.target.type === 'checkbox' ? ev.target.checked : ev.target.value;
      if (st.scr === 'contact' && !cfg.loggedIn && (k === 'gname' || k === 'gmail' || k === 'phone') && (touched[k] || tried.contact)) gMark(k);
    });
    root.addEventListener('focusout', function (ev) {
      var k = ev.target.getAttribute && ev.target.getAttribute('data-in');
      if (st.scr !== 'contact' || cfg.loggedIn || !(k === 'gname' || k === 'gmail' || k === 'phone')) return;
      if (!String(st[k] || '').trim() && !tried.contact) return;
      touched[k] = true; gMark(k);
    });
    root.addEventListener('change', function (ev) {
      var k = ev.target.getAttribute && ev.target.getAttribute('data-in');
      if (k && ev.target.type === 'checkbox') { st[k] = ev.target.checked; if (tried.confirm) { msg = ''; render(); } }
    });
    root.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter' && st.scr === 'contact' && ev.target.tagName === 'INPUT') { ev.preventDefault(); var n = $('.akf-next', body); if (n) n.click(); }
    });

    // ---------- başlangıç ----------
    var restored = restore();
    if (FIX && st.who && !whoList().some(function (w) { return w[0] === st.who; })) { st.who = ''; st.scr = 'who'; }
    function verifyRestored() {
      if (['contact', 'confirm', 'plan', 'repeat'].indexOf(st.scr) < 0) return Promise.resolve();
      if (!st.slot || !st.expert) { st.scr = 'time'; return Promise.resolve(); }
      return loadLive().then(loadUnion).then(function (days) {
        var ok = days.some(function (d) { return d.slots.some(function (s) { return s.ts === st.slot && s.ex.indexOf(st.expert) >= 0; }); });
        if (!ok) { st.slot = null; st.expert = null; st.scr = 'time'; msg = 'Seçtiğiniz saat bu arada doldu. Lütfen yeni bir saat seçin.'; }
        else days.forEach(function (d, i) { if (d.slots.some(function (s) { return s.ts === st.slot; })) st.day = i; });
      }).catch(function () { /* saat ekranında yeniden denenir */ });
    }
    var pre = cfg.loggedIn && !FIX
      ? api('/me').then(function (d) {
          var credit = (d.packages || []).filter(function (p) { return p.total > p.used; })[0];
          var last = (d.bookings || []).filter(function (b) { return ['cancelled', 'released'].indexOf(b.status) < 0; }).sort(function (a, b) { return b.start - a.start; })[0];
          var id = credit ? credit.expert : last ? last.expert : null;
          if (id && EX[id]) {
            st.prev = id;
            if (credit) st.credits[id] = (d.packages || []).filter(function (p) { return p.expert === id; }).reduce(function (s, p) { return s + p.total - p.used; }, 0);
            if (st.keep === null) st.scr = 'keep';
          }
        }).catch(function () { /* yeni danışan */ })
      : Promise.resolve();
    body.innerHTML = '<div class="akf-load" aria-busy="true"><span class="akf-sk akf-sk--line"></span><span class="akf-sk akf-sk--opt"></span><span class="akf-sk akf-sk--opt"></span></div>';
    pre.then(verifyRestored).then(function () {
      render();
      if (restored || location.hash === '#randevu-formu') setTimeout(function () { toTop(false); }, 60);
      if (restored && FIX) root.dispatchEvent(new CustomEvent('akf:restored', { bubbles: true }));
    });
  }

  function boot() { $$('[data-akf]').forEach(function (r) { if (!r.__akf4) { r.__akf4 = 1; initForm(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
